"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationDotType = exports.NotificationDot = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let NotificationDotType;
exports.NotificationDotType = NotificationDotType;
(function (NotificationDotType) {
  NotificationDotType["DESKTOP_HEADER"] = "desktop_header";
  NotificationDotType["MENU_ITEM"] = "menu_item";
})(NotificationDotType || (exports.NotificationDotType = NotificationDotType = {}));
const THEME = {
  desktopHeader: {
    position: "mb-16 mr-2 relative h-6 w-6 rounded-full",
    bg: "bg-white"
  },
  menuItem: {
    position: "rounded-full h-8 w-8 ml-8",
    bg: "bg-primary-3667e9"
  }
};
const NotificationDot = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    id,
    type,
    ...props
  } = _ref;
  const thisRef = (0, _react.useRef)(null);
  const thisRefProp = (0, _react2.useMergeRefs)([thisRef, ref]);
  switch (type) {
    case NotificationDotType.MENU_ITEM:
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        ref: thisRefProp,
        id: id,
        className: (0, _classnames.default)(THEME.menuItem.position, THEME.menuItem.bg)
      }, props));
      break;
    case NotificationDotType.DESKTOP_HEADER:
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        ref: thisRefProp,
        className: (0, _classnames.default)(THEME.desktopHeader.position, THEME.desktopHeader.bg),
        id: id
      }, props));
      break;
    default:
      return null;
  }
});
exports.NotificationDot = NotificationDot;
NotificationDot.displayName = "NavBar.NotificationDot";